import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import {
  primaryButtonStyles,
  secondaryButtonStyles,
} from "../../../Styles/Styles";

const ConfirmModal = ({ open, onClose, onConfirm, title, message }) => {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontFamily: "ClashGrotesk-Medium", letterSpacing: 1 }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{ fontFamily: "ClashGrotesk-Regular", letterSpacing: 1 }}
        >
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{ ...secondaryButtonStyles }}
        >
          No
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{ ...primaryButtonStyles }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
